/**
 * Max "submit a review of your guest" cards shown in the recommended section.
 * If the host has more pending guest reviews, only the first few
 * (alphabetical by listing title) are surfaced here.
 */
export const MAX_SUBMIT_GUEST_REVIEW_CARDS = 3;

/** Square pixel size (1x) requested for the listing thumbnail on a card. */
export const SUBMIT_GUEST_REVIEW_THUMBNAIL_PX = 80;

/** Square pixel size (1x) requested for the guest avatar on a card. */
export const SUBMIT_GUEST_REVIEW_AVATAR_PX = 100;
